// extracted by mini-css-extract-plugin
export var layoutContainer = "_3u-0";
export var layoutContainerOpen = "_3u-5";
export var layoutContainerResizing = "_3u-1";
export var mainContent = "_3u-2";
export var resizeDivider = "_3u-3";
export var slidePanel = "_3u-4";